const STATS = [
  { value: "+60.000", label: "Clientes ativos confiando na operação" },
  { value: "10 anos", label: "De mercado e operação contínua" },
  { value: "100%", label: "De adimplência desde o início" },
  { value: "3ª maior", label: "Empresa do mundo no segmento" },
];

export const AssessoresStats = () => {
  return (
    <section className="bg-[#FAF8F5] py-16 sm:py-20 md:py-24">
      <div className="container-wide px-6 sm:px-6 md:px-12">
        <div className="flex justify-center mb-10 sm:mb-12">
          <span className="inline-flex items-center rounded-full bg-[#34F285]/[0.06] px-4 py-1.5 text-xs font-medium text-[#1F3D2E] ring-1 ring-[#1F3D2E]/10">
            Credibilidade
          </span>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="bg-white rounded-2xl p-6 text-center shadow-[0_8px_30px_-12px_rgba(50,63,79,0.15)]"
            >
              <div
                className="text-2xl sm:text-3xl font-extrabold text-[#2E694D]"
                style={{
                  fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                }}
              >
                {s.value}
              </div>
              <div className="mt-1.5 text-xs sm:text-sm text-zinc-600 leading-snug">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-center text-[11px] sm:text-xs text-zinc-500 max-w-3xl mx-auto leading-relaxed">
          Operação Allugator Serviços Digitais · Emissão via Allu Invest
          Securitizadora · Divulgação Dexcap (CVM 88)
        </p>
      </div>
    </section>
  );
};
